import { render, staticRenderFns } from "./ProfilEntreprises.vue?vue&type=template&id=f23bdd1a&"
import script from "./ProfilEntreprises.vue?vue&type=script&lang=ts&"
export * from "./ProfilEntreprises.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports